// Isolated JSON storage for regression scenarios. This adapter never accesses Supabase or R2.
export function createRegressionTestClient(initial = {}, options = {}) {
  const clone = value => JSON.parse(JSON.stringify(value));
  const database = clone(initial);
  let sequence = 0;
  const client = { database, options, from(table) {
    database[table] = database[table] || [];
    let action = 'read', payload, filters = [], windowRange;
    const query = {
      select: () => query,
      eq: (field, value) => { filters.push(row => field === 'config' ? JSON.stringify(row[field]) === value : row[field] === value); return query; },
      is: (field, value) => { filters.push(row => row[field] === value); return query; },
      in: (field, values) => { filters.push(row => values.includes(row[field])); return query; },
      like: (field, value) => { filters.push(row => String(row[field] || '').startsWith(value.replace(/%$/, ''))); return query; },
      range: (start, end) => { windowRange = [start, end]; return query; },
      insert: value => { action = 'insert'; payload = value; return query; },
      update: value => { action = 'update'; payload = value; return query; },
      upsert: value => { action = 'upsert'; payload = value; return query; },
      delete: () => { action = 'delete'; return query; },
      single: async () => { const result = await execute(); return { ...result, data: result.data?.[0] || null }; },
      then: (resolve, reject) => execute().then(resolve, reject),
    };
    async function execute() {
      const failure = options.fail?.({ table, action, payload });
      if (failure) return { data: null, error: { message: String(failure) } };
      const collection = database[table];
      let matches = collection.filter(row => filters.every(filter => filter(row)));
      if (windowRange) matches = matches.slice(windowRange[0], windowRange[1] + 1);
      if (action === 'insert') {
        matches = (Array.isArray(payload) ? payload : [payload]).map(row => ({ id: `fixture-${++sequence}`, ...clone(row) }));
        collection.push(...matches);
      } else if (action === 'update') matches.forEach(row => Object.assign(row, clone(payload)));
      else if (action === 'upsert') {
        matches = (Array.isArray(payload) ? payload : [payload]).map(row => {
          let existing = collection.find(item => item.employee_id === row.employee_id && item.month === row.month && item.year === row.year);
          if (existing) Object.assign(existing, clone(row));
          else { existing = { id: `fixture-${++sequence}`, ...clone(row) }; collection.push(existing); }
          return existing;
        });
      } else if (action === 'delete') {
        database[table] = collection.filter(row => !matches.includes(row));
        if (table === 'companies' && options.cascade !== false) {
          const ids = new Set(matches.map(row => row.id));
          for (const child of ['employees', 'salary_records']) database[child] = (database[child] || []).filter(row => !ids.has(row.company_id));
        }
      }
      return { data: clone(matches), error: null };
    }
    return query;
  } };
  return client;
}
